import React from "react";
import { VelavuAsset } from "velavu-js-api";
import ConnectionStatus from "../data/connection-status";
import VelavuItemIcon from "./velavu-item-icon";
import { useAssetImageURLCache } from "../components/main/asset-image-url-cache-provider";

export interface VelavuAssetItemIconProps {
	asset: Pick<VelavuAsset, "id" | "category" | "profile_img_url">;
	status?: ConnectionStatus;
}

/**
 * A wrapper around VelavuItemIcon that resolves image URLs
 * for assets
 */
export default function VelavuAssetItemIcon(props: VelavuAssetItemIconProps) {
	const { asset, status } = props;

	const cache = useAssetImageURLCache();

	if (asset.profile_img_url !== undefined) {
		//If the asset has an image URL built-in, display it immediately
		return (
			<VelavuItemIcon
				data={{ url: asset.profile_img_url }}
				status={status}
			/>
		);
	} else {
		//Look up the image URL
		const imageURL = cache.getAssetImageURL(asset.id);

		if (imageURL) {
			return <VelavuItemIcon data={{ url: imageURL }} status={status} />;
		} else {
			return (
				<VelavuItemIcon
					data={{ category: asset.category }}
					status={status}
				/>
			);
		}
	}
}
